import { useQuery } from "react-query";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import axios from "infra/http";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { SolicitacaoCadastroListItem } from "../typings";

function useGetSolicitacaoCadastro(filtro: PaginateQuery) {
  const { tenant } = useCurrentTenant();

  return useQuery(["/v1/solicitacao-cadastro", filtro], async () => {
    const res = await axios.get<PaginateResult<SolicitacaoCadastroListItem>>(
      "/v1/solicitacao-cadastro",
      {
        params: filtro,
        headers: { tenant: tenant!.id },
      }
    );

    return res.data;
  });
}

export default useGetSolicitacaoCadastro;
